// extracted by mini-css-extract-plugin
module.exports = {"popover":"Popovers_popover__25B5D","sliderPopover":"SliderPopover_sliderPopover__21ED2 Popovers_popover__25B5D","sliderTitle":"SliderPopover_sliderTitle__lG-fa"};